// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___2PXdW","img":"img___1BjG2","title":"title___3H9cl","content":"content___3gU51","btnLine":"btnLine___YEiSx"};